import { CGU } from '@components/consents/CGU';
import { COMMON } from '@constants';
import styled from '@emotion/styled';
import { OutboundLinkContext } from '@enums';
import { Button } from '@lib/uikit';
import { FormStatus } from '@types';
import { useFormikContext } from 'formik';
import { useTranslation } from 'next-i18next';

import { useFormContext } from '../contexts/FormContext';
import { useSurveyContext } from '../contexts/SurveyContext';

const Container = styled.div`
    width: 100%;
    position: relative;
    height: 100%;
    padding: ${({ theme }) => theme.spacing.md};
    background-color: ${({ theme }) => theme?.palette.background?.default};
`;

const Stack = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${(props) => props.theme.spacing.sm};
`;

const SurveyPageFooter = () => {
    const { currentSurveyPage, isRedirecting } = useSurveyContext();
    const { continueSurvey, isSubmitting, isContinueDisabled } =
        useFormContext();
    const { t } = useTranslation(COMMON);
    const { status } = useFormikContext();

    return (
        <Container>
            <Stack>
                <Button
                    isFullWidth
                    onClick={continueSurvey}
                    disabled={
                        isContinueDisabled ||
                        status === FormStatus.UPLOADING ||
                        status === FormStatus.DISABLED
                    }
                    isLoading={isSubmitting || isRedirecting}
                >
                    {currentSurveyPage?.CtaText || t('continue')}
                </Button>
                {currentSurveyPage?.WithCGU && (
                    <CGU outboundLinkContext={OutboundLinkContext.Footer} />
                )}
            </Stack>
        </Container>
    );
};

export default SurveyPageFooter;
